export class ClientSearchCriteria {
  nameOrShortnameOrBillingAccount: string;
  userNameOrEmail: string;
  status: string;
  canSeeGraphMckay: boolean;
  canSeeGraphQuincy: boolean;
  canSeeGraphVendor: boolean;
  activeDadReport: boolean;
  dadIce: boolean;
  dadEurex: boolean;
  dadEuronext: boolean;
  dadLme: boolean;
  dadLse: boolean;
  dadTurq: boolean;

  constructor(userChoicesActiveFilters) {
    this.nameOrShortnameOrBillingAccount = userChoicesActiveFilters.Name;
    this.userNameOrEmail = userChoicesActiveFilters.UserName;
    this.canSeeGraphMckay = userChoicesActiveFilters.CanSeeGraphMckay;
    this.canSeeGraphQuincy = userChoicesActiveFilters.CanSeeGraphQuincy;
    this.canSeeGraphVendor = userChoicesActiveFilters.CanSeeGraphVendor;
    this.status = userChoicesActiveFilters.Status;
    this.activeDadReport = userChoicesActiveFilters.ActiveDadReport;
    this.dadIce = userChoicesActiveFilters.DadIce;
    this.dadEurex = userChoicesActiveFilters.DadEurex;
    this.dadEuronext = userChoicesActiveFilters.DadEuronext;
    this.dadLme = userChoicesActiveFilters.DadLme;
    this.dadLse = userChoicesActiveFilters.DadLse;
    this.dadTurq = userChoicesActiveFilters.DadTurq;
  }
}
